import {
  faCartPlus,
  faChevronLeft,
  faChevronRight,
  faEnvelope,
  faPrint,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactToPrint from "react-to-print-advanced";
import {
  cartPostAction,
  getCartItems,
  removeItemFromCart,
} from "../../actions/cartAction";
import { getPatientNotification } from "../../actions/dashboardAction";
import {
  practitonerPrescriptionPostAction,
  prescriptionPageTabShowItemList as setItemToTab,
} from "../../actions/prescriptionAction";
import RxIcon from "../../assets/images/rx-icon.png";
import ConfirmDialog from "../../components/ConfirmDialog";
import ItemSwitch from "../../components/ItemSwitch";
import { ERROR } from "../../constants/types/alertType";
import { formatDate, getUserDetail } from "../../utils/helper";
import history from "../../utils/history";
import { getCreatePrescriptionPatients } from "../../actions/patientAction";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import AddEmailPopup from "./AddEmailPopup";
const ReviewPage = ({
  multiplier,
  totalPacket,
  disease,
  pattern,
  formula,
  mod,
  formulaName,
  formulaNote,
  commission,
  prepMethod,
  patientName,
  setPatientEmail,
  patientEmail,
  patientId,
  packetsPerDay,
  days,
  scoops,
  timePerDay,
  totalValue,
  prepValue,
  setActiveSection,
  patientInstruction,
  pharmacyInstruction,
  notesOnPrescription,
  prescriptionPageTabShowItemList,
}) => {
  const isRaw = useSelector((state) => state.formula.present.isRawType);
  const appLoading = useSelector((state) => state.alert.appLoading);
  const orderedPrescription = useSelector(
    (state) => state.prescription.practitionerHistoryPresctionDetail
  );
  const formulas = useSelector((state) => state.formula.present.formulaSection);
  const singleHerbList = useSelector(
    (state) => state.formula.present.singleHerbList
  );
  const singleHerbTotal = useSelector(
    (state) => state.formula.present.singleHerbTotal
  );
  const overall = useSelector((state) => state.formula.present.overall);
  const componentRef = useRef();
  const [practitionerView, setPractitionerView] = useState(true);
  const [showAddEmailPopup, setShowAddEmailPopup] = useState(false);
  const unfinalizedPrescriptionId = useSelector(
    (state) => state.prescription.unfinalizedPrescriptionId
  );
  const prescriptionFormFields = useSelector(
    (state) => state.settings.prescriptionFormFields
  );
  const cartItems = useSelector((state) => state.cart.activeCartItem);
  const role = useSelector((state) => state.role.role);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const dispatch = useDispatch();
  const removeItem = (item) => {
    var params = {
      params: {
        action: "removeCartItem",
        itemId: item.prescriptionId,
        isPrescription: 1,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      cartPostAction(params, () => {
        dispatch(getPatientNotification(role.val));
      })
    );
  };
  const handleSendToPatient = () => {
    if (patientEmail) {
      let oldItem = cartItems.find(
        (x) => x.prescriptionId == unfinalizedPrescriptionId && x.isPrescription
      );
      if (oldItem) {
        removeItem(oldItem);
      }
      const data = {
        params: {
          action: "sendPatientPrescription",
          prescription_id: unfinalizedPrescriptionId,
          token: getUserDetail()?.token,
        },
      };
      dispatch(
        practitonerPrescriptionPostAction(data, () => {
          dispatch(setItemToTab([1]));
          setActiveSection(0);
          dispatch(getCreatePrescriptionPatients());
          window.location.reload();
        })
      );
    } else {
      setShowAddEmailPopup(true);
    }
  };
  const handleCheckout = () => {
    let oldItem = cartItems.find(
      (x) => x.prescriptionId == unfinalizedPrescriptionId && x.isPrescription
    );

    if (oldItem) {
      // dispatch({
      //   type: ERROR,
      //   payload: "Item is already in your cart",
      // });
      history.push("/app/shopping");
      return;
    }
    let roleId = role.val == 3 ? role.val : role.val == 4 ? role.val : 1;
    var params = {
      params: {
        action: "addCartItem",
        itemId: unfinalizedPrescriptionId,
        isPrescription: 1,
        quantity: null,
        roleId: roleId,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      cartPostAction(params, () => {
        dispatch(getCartItems(role.val));
        dispatch(getPatientNotification(role.val));
        history.push("/app/shopping");
      })
    );
  };
  const handleAddToCart = () => {
    let oldItem = cartItems.find(
      (x) => x.prescriptionId == unfinalizedPrescriptionId && x.isPrescription
    );
    if (oldItem) {
      dispatch({
        type: ERROR,
        payload: "Item is already in your cart",
      });
      return;
    }
    let roleId = role.val == 3 ? role.val : role.val == 4 ? role.val : 1;
    var params = {
      params: {
        action: "addCartItem",
        itemId: unfinalizedPrescriptionId,
        isPrescription: 1,
        quantity: 1,
        roleId: roleId,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      cartPostAction(params, () => {
        dispatch(getCartItems(role.val));
        dispatch(getPatientNotification(role.val));
      })
    );

    dispatch(setItemToTab([1]));
    setActiveSection(0);
  };
  return (
    <div className="review-page row">
      {showAddEmailPopup && (
        <AddEmailPopup
          closePopup={() => setShowAddEmailPopup(false)}
          patientId={patientId}
          setPatientEmail={setPatientEmail}
          handleSendToPatient={handleSendToPatient}
        />
      )}
      <div className="col-md-12">
        <div className="row">
          <div className="col-md-8">
            <p className="page-desc">
              Please review your order, print or use the above tabs to go back
              and edit the prescription.
            </p>
          </div>
          <div className="col-md-4">
            <ItemSwitch
              itemOneText="Practitioner"
              itemTwoText="Patient"
              switchText="View"
              switchValue={practitionerView}
              switchAction={setPractitionerView}
            />
          </div>
        </div>
      </div>
      <div className="col-md-12">
        {orderedPrescription && (
          <>
            <div className="item-section" ref={componentRef}>
              <div className="row">
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-6 reduce-height">
                      <h5>Practitioner:</h5>
                    </div>
                    <div className="col-md-6 reduce-height">
                      <p>
                        {getUserDetail()?.firstName} {getUserDetail()?.lastName}
                      </p>
                    </div>
                    <div className="col-md-6 reduce-height">
                      <h5>Patient:</h5>
                    </div>
                    <div className="col-md-6 reduce-height">
                      <p>{patientName}</p>
                    </div>
                    <div className="col-md-6 reduce-height">
                      <h5>Prescription #:</h5>
                    </div>
                    <div className="col-md-6 reduce-height">
                      <p>{unfinalizedPrescriptionId}</p>
                    </div>
                    <div className="col-md-6 reduce-height">
                      <h5>Date:</h5>
                    </div>
                    <div className="col-md-6 reduce-height">
                      <p>
                        {orderedPrescription[0]
                          ? formatDate(orderedPrescription[0]?.Created_Date)
                          : formatDate(new Date())}
                      </p>
                    </div>
                  </div>
                  {practitionerView && (
                    <div className="row mt-1">
                      <div className="col-md-6 reduce-height">
                        <h5>Disease:</h5>
                      </div>
                      <div className="col-md-6 reduce-height">
                        <p>{disease}</p>
                      </div>
                      <div className="col-md-6 reduce-height">
                        <h5>Pattern:</h5>
                      </div>
                      <div className="col-md-6 reduce-height">
                        <p>{pattern}</p>
                      </div>
                      <div className="col-md-6 reduce-height">
                        <h5>Formula(s):</h5>
                      </div>
                      <div className="col-md-6 reduce-height">
                        <p>{formula}</p>
                      </div>
                      <div className="col-md-6 reduce-height">
                        <h5>Mod(s):</h5>
                      </div>
                      <div className="col-md-6 reduce-height">
                        <p>{mod}</p>
                      </div>
                      <div className="col-md-6 reduce-height">
                        <h5>Dosage Type:</h5>
                      </div>
                      <div className="col-md-6 reduce-height">
                        <p>{isRaw ? "Raw" : "Granular"}</p>
                      </div>
                      <div className="col-md-6 reduce-height">
                        <h5>PREPARATION METHOD:</h5>
                      </div>
                      <div className="col-md-6 reduce-height">
                        <p>{prepMethod?.prepMethod}</p>
                        {console.log(prepMethod)}
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-md-4 icon">
                  <img src={RxIcon} />
                </div>
              </div>
              <div className="formula-table mt-4">
                <table className="table table_review">
                  <thead>
                    <tr>
                      <th>FORMULA(S) &amp; HERB(S)</th>
                      <th style={{ paddingRight: 0 }} className="text-right">
                        DOSAGE
                      </th>
                      {practitionerView && (
                        <th style={{ paddingRight: 0 }} className="text-right">
                          PRICE
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {formulas.length > 0 &&
                      formulas.map((x) => {
                        return (
                          <>
                            <tr className="herb-title" key={x.formulaName}>
                              <td>{x.formulaName}</td>
                            </tr>
                            {x.formulaHerbs
                              .filter((y) => !y.isModification)
                              .map((y, index, array) => {
                                return (
                                  <>
                                    <tr key={y.id}>
                                      <td>{y.name}</td>
                                      <td className="text-right">
                                        {index === array.length - 1 &&
                                        y.id > 0 ? (
                                          `+${parseFloat(
                                            y.dosage
                                          ).toLocaleString("en-US", {
                                            maximumFractionDigits: 1,
                                            minimumFractionDigits: 1,
                                          })}`
                                        ) : (
                                          <p
                                            style={{ marginBottom: 0 }}
                                            className={`${
                                              y.id == 0
                                                ? "sunten-formula-fix"
                                                : ""
                                            }`}
                                          >
                                            {parseFloat(
                                              y.dosage
                                            ).toLocaleString("en-US", {
                                              maximumFractionDigits: 1,
                                              minimumFractionDigits: 1,
                                            })}
                                          </p>
                                        )}
                                      </td>
                                      {practitionerView && (
                                        <td className="text-right">
                                          {index === array.length - 1 &&
                                          y.id > 0 ? (
                                            `+${parseFloat(
                                              y.price
                                            ).toLocaleString("en-US", {
                                              maximumFractionDigits: 2,
                                              minimumFractionDigits: 2,
                                              style: "currency",
                                              currency: "USD",
                                            })}`
                                          ) : (
                                            <p
                                              style={{ marginBottom: 0 }}
                                              className={`${
                                                y.id == 0
                                                  ? "sunten-formula-fix"
                                                  : ""
                                              }`}
                                            >
                                              {parseFloat(
                                                y.price
                                              ).toLocaleString("en-US", {
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2,
                                                style: "currency",
                                                currency: "USD",
                                              })}
                                            </p>
                                          )}
                                        </td>
                                      )}
                                    </tr>
                                  </>
                                );
                              })}
                            <tr>
                              <td>
                                <p
                                  className="ml-2 mb-1 mt-1"
                                  style={{ fontSize: "16px" }}
                                >
                                  {x.modificationName}
                                </p>
                              </td>
                            </tr>
                            {x.formulaHerbs
                              .filter((y) => y.isModification)
                              .map((y, index, array) => {
                                return (
                                  <>
                                    <tr key={y.id}>
                                      <td>{y.name}</td>
                                      <td className="text-right">
                                        {index === array.length - 1
                                          ? `+${parseFloat(
                                              y.dosage
                                            ).toLocaleString("en-US", {
                                              maximumFractionDigits: 1,
                                              minimumFractionDigits: 1,
                                            })}`
                                          : parseFloat(y.dosage).toLocaleString(
                                              "en-US",
                                              {
                                                maximumFractionDigits: 1,
                                                minimumFractionDigits: 1,
                                              }
                                            )}
                                      </td>
                                      {practitionerView && (
                                        <td className="text-right">
                                          {index === array.length - 1
                                            ? `+${parseFloat(
                                                y.price
                                              ).toLocaleString("en-US", {
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2,
                                                style: "currency",
                                                currency: "USD",
                                              })}`
                                            : parseFloat(
                                                y.price
                                              ).toLocaleString("en-US", {
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2,
                                                style: "currency",
                                                currency: "USD",
                                              })}
                                        </td>
                                      )}
                                    </tr>
                                  </>
                                );
                              })}
                            {!x.isSuntenFormula && (
                              <tr>
                                <td className="total-practitioner">
                                  Formula Total:
                                </td>
                                <td className="d-flex justify-content-end">
                                  <p className="hr-replacement">
                                    {parseFloat(x.formulaDosage).toLocaleString(
                                      "en-US",
                                      {
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1,
                                      }
                                    )}
                                  </p>
                                </td>
                                {practitionerView && (
                                  <td className="text-right">
                                    <div className="d-flex justify-content-end">
                                      <p className="hr-replacement">
                                        {parseFloat(
                                          x.formulaPrice
                                        ).toLocaleString("en-US", {
                                          maximumFractionDigits: 2,
                                          minimumFractionDigits: 2,
                                          style: "currency",
                                          currency: "USD",
                                        })}
                                      </p>
                                    </div>
                                  </td>
                                )}
                              </tr>
                            )}
                          </>
                        );
                      })}
                    {singleHerbList.length > 0 && (
                      <>
                        <tr className="herb-title">
                          <td>Single Herbs</td>
                        </tr>
                        {singleHerbList.map((x) => {
                          return (
                            <tr key={x.herb_id}>
                              <td>{x.name}</td>
                              <td className="text-right">
                                {parseFloat(x.dosage).toLocaleString("en-US", {
                                  maximumFractionDigits: 1,
                                  minimumFractionDigits: 1,
                                })}
                              </td>
                              {practitionerView && (
                                <td className="text-right">
                                  {parseFloat(x.price).toLocaleString("en-US", {
                                    maximumFractionDigits: 2,
                                    minimumFractionDigits: 2,
                                    style: "currency",
                                    currency: "USD",
                                  })}
                                </td>
                              )}
                            </tr>
                          );
                        })}

                        <tr>
                          <td className="total-practitioner">
                            Single Herbs Total:
                          </td>
                          <td className="d-flex justify-content-end">
                            <p className="hr-replacement">
                              {parseFloat(
                                singleHerbTotal.totalDosage
                              ).toLocaleString("en-US", {
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1,
                              })}
                            </p>
                          </td>

                          {practitionerView && (
                            <td className="text-right">
                              <div className="d-flex justify-content-end">
                                <p className="hr-replacement">
                                  {parseFloat(
                                    singleHerbTotal.totalPrice
                                  ).toLocaleString("en-US", {
                                    maximumFractionDigits: 2,
                                    minimumFractionDigits: 2,
                                    style: "currency",
                                    currency: "USD",
                                  })}
                                </p>
                              </div>
                            </td>
                          )}
                        </tr>
                      </>
                    )}
                    {!practitionerView && isRaw && (
                      <>
                        <tr>
                          <td className="total-practitioner">Per Packet:</td>
                          <td className="text-right">
                            <div className="d-flex justify-content-end">
                              <p className="hr-replacement">
                                {overall.totalDosage.toLocaleString("en-US", {
                                  maximumFractionDigits: 1,
                                  minimumFractionDigits: 1,
                                })}
                              </p>
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="total-practitioner">
                            Number of Packets:
                          </td>
                          <td className="text-right">x {totalPacket}</td>
                        </tr>
                      </>
                    )}
                    {practitionerView && (
                      <>
                        {isRaw ? (
                          <>
                            <tr>
                              <td></td>
                              <td></td>

                              <div className="d-flex justify-content-end">
                                <div
                                  style={{
                                    borderTop: "1px solid black",
                                    width: "100%",
                                    marginRight: "2px",
                                    marginLeft: "-40px",
                                  }}
                                ></div>
                              </div>
                            </tr>

                            <tr>
                              <td className="total-practitioner">
                                Per Packet:
                              </td>
                              <td className="d-flex justify-content-end">
                                <p
                                  className="hr-replacement"
                                  style={{ marginTop: "-1px" }}
                                >
                                  {overall.totalDosage.toLocaleString("en-US", {
                                    maximumFractionDigits: 1,
                                    minimumFractionDigits: 1,
                                  })}{" "}
                                </p>
                              </td>
                              <td className="text-right">
                                <div className="d-flex justify-content-end ">
                                  <p style={{ margin: 0, fontSize: "14px" }}>
                                    {overall.totalPrice.toLocaleString(
                                      "en-US",
                                      {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2,
                                        style: "currency",
                                        currency: "USD",
                                      }
                                    )}
                                  </p>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td className="total-practitioner">
                                Number of Packets:
                              </td>
                              <td className="text-right">x {totalPacket}</td>
                              <td className="text-right">x {totalPacket}</td>
                            </tr>
                            <tr className="line">
                              <td></td>

                              <td className="text-right">
                                <div className="d-flex justify-content-end">
                                  <div
                                    style={{
                                      borderTop: "1px solid black",
                                      width: "50px",
                                      marginRight: "2px",
                                    }}
                                  ></div>
                                </div>
                              </td>
                            </tr>
                          </>
                        ) : (
                          ""
                        )}
                        <tr>
                          <td className="total-practitioner">Subtotal:</td>
                          <td></td>
                          <td className="d-flex justify-content-end">
                            <p className="hr-replacement">
                              {isRaw
                                ? (
                                    overall.totalPrice * totalPacket
                                  ).toLocaleString("en-US", {
                                    maximumFractionDigits: 2,
                                    minimumFractionDigits: 2,
                                    style: "currency",
                                    currency: "USD",
                                  })
                                : parseFloat(overall.totalPrice).toLocaleString(
                                    "en-US",
                                    {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2,
                                      style: "currency",
                                      currency: "USD",
                                    }
                                  )}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td className="total-practitioner">Commission:</td>
                          <td></td>
                          <td className="text-right">
                            {isRaw
                              ? (
                                  overall.totalPrice *
                                  totalPacket *
                                  (commission / 100)
                                ).toLocaleString("en-US", {
                                  maximumFractionDigits: 2,
                                  minimumFractionDigits: 2,
                                  style: "currency",
                                  currency: "USD",
                                })
                              : (
                                  overall.totalPrice *
                                  (commission / 100)
                                ).toLocaleString("en-US", {
                                  maximumFractionDigits: 2,
                                  minimumFractionDigits: 2,
                                  style: "currency",
                                  currency: "USD",
                                })}
                          </td>
                        </tr>
                        <tr>
                          <td className="total-practitioner">
                            Preparation Cost:
                          </td>
                          <td></td>
                          <td className="text-right">
                            +{" "}
                            {prepValue.toLocaleString("en-US", {
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                              style: "currency",
                              currency: "USD",
                            })}
                          </td>
                        </tr>
                      </>
                    )}

                    <tr>
                      <td className="total-practitioner">Total:</td>
                      <td className="d-flex justify-content-end">
                        <p className="hr-replacement">
                          {isRaw
                            ? (
                                overall.totalDosage * totalPacket
                              ).toLocaleString("en-US", {
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1,
                              })
                            : overall.totalDosage.toLocaleString("en-US", {
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1,
                              })}
                        </p>
                      </td>

                      {practitionerView && (
                        <td className="text-right">
                          <div className="d-flex justify-content-end">
                            <p className="hr-replacement">
                              {parseFloat(totalValue).toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2,
                                style: "currency",
                                currency: "USD",
                              })}
                            </p>
                          </div>
                        </td>
                      )}
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="serving-section">
                {scoops == 0 || timePerDay == 0 || days == 0 ? (
                  ""
                ) : (
                  <>
                    <h3>Serving Instructions</h3>

                    {isRaw ? (
                      <p>
                        {packetsPerDay} packet(s) a day for {days} day(s)
                      </p>
                    ) : (
                      <p>
                        {scoops}{" "}
                        {prepMethod.id == 5
                          ? " capsule(s) "
                          : prepMethod.id == 1
                          ? " scoop(s) "
                          : prepMethod.id == 6
                          ? " tablet(s) "
                          : "scoop(s)"}
                        , {timePerDay} times a day(s) for {days} day(s)
                      </p>
                    )}
                  </>
                )}
                {patientInstruction && (
                  <>
                    <h3 className="mt-2">Patient Instructions</h3>
                    <p>{patientInstruction}</p>
                  </>
                )}
                {practitionerView && notesOnPrescription && (
                  <>
                    <h3 className="mt-2">Notes on Prescription</h3>
                    <p>{notesOnPrescription}</p>
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </div>
      <div className="col-md-12 mt-2">
        <div className="row ml-4">
          <div className="col-md-6 d-flex">
            <button
              className="white-btn"
              onClick={() => {
                prescriptionPageTabShowItemList.includes(3)
                  ? setActiveSection(2)
                  : setActiveSection(1);
              }}
            >
              <FontAwesomeIcon size="xs" icon={faChevronLeft} /> back
            </button>
            <ReactToPrint
              trigger={() => (
                <button className="white-btn">
                  <FontAwesomeIcon size="xs" icon={faPrint} /> Print
                </button>
              )}
              content={() => componentRef.current}
            />
          </div>
          <div className="col-md-6 d-flex justify-content-end">
            {showConfirmDialog && (
              <ConfirmDialog
                title="This Prescription is currently in your cart. do you wish to continue to send it to the patient and remove from your cart?"
                acceptAction={() => {
                  handleSendToPatient();
                }}
                acceptText="yes"
                rejectText="no"
                closePopup={() => setShowConfirmDialog(false)}
              />
            )}
            {/* <OverlayTrigger
              placement="right"
              delay={{ show: 200, hide: 100 }}
              overlay={
                <Tooltip id="button-tooltip-2">
                  Send to patient is temporary disabled.
                </Tooltip>
              }
            > */}
            <button
              className="white-btn orange"
              onClick={() => {
                let oldItem = cartItems.find(
                  (x) =>
                    x.prescriptionId == unfinalizedPrescriptionId &&
                    x.isPrescription
                );

                if (oldItem) {
                  setShowConfirmDialog(true);
                } else {
                  handleSendToPatient();
                }
              }}
            >
              {" "}
              <FontAwesomeIcon size="xs" icon={faEnvelope} /> Send to patient
            </button>
            {/* </OverlayTrigger> */}
            <button className="white-btn orange mr-5" onClick={handleAddToCart}>
              {" "}
              <FontAwesomeIcon size="xs" icon={faCartPlus} /> Add to cart
            </button>
            <button className="white-btn orange mr-5" onClick={handleCheckout}>
              {" "}
              Checkout <FontAwesomeIcon size="xs" icon={faChevronRight} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ReviewPage;
